export enum ProbateRotateSegments {
  start = 'start',
  dashboard = 'dashboard',
  bondSurety = 'bond-surety',
  taxes = 'taxes',
  messages = 'messages',
  notes = 'notes',
  forms = 'forms',
  estate = 'estate',
  documents = 'documents',
  heirs = 'heirs',
  will = 'will',
  subscriber = 'subscriber',
  home = 'home',
  decedent = 'decedent',
}
